module.exports = __webpack_public_path__ + "396f4ec689d55b477922fb03a44aa5b7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/quanta_services_2021_chart.png
// module id = 1722
// module chunks = 0